var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _circle, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.g{opacity:0.3;}.a{fill:url(#a);}.b{fill:url(#b);}.c,.h,.i,.j{fill:#fff;}.c{opacity:0.52;}.d{fill:url(#c);}.e{fill:url(#d);}.f{fill:url(#e);}.i{opacity:0.5;}.j,.k{opacity:0.78;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 137.65,
    y1: 150.02,
    x2: 52.28,
    y2: 57.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b37cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f895e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 13.49,
    y1: 20.97,
    x2: 62.34,
    y2: 101.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a737d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef497a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 118.68,
    y1: 153.13,
    x2: 16.58,
    y2: 89.53,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 38.48,
    y1: 76.16,
    x2: 123.57,
    y2: 76.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 47.51,
    y1: 130.12,
    x2: 169.95,
    y2: -65.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#53d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840f7"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M125.8,97.5c-11.8,27.4-42.7,39.2-67,37.2-6.6-.5-20-1.7-30.4-11.5C8.5,104.3,11.5,64.8,30.7,41.5c2.4-2.9,19.5-23,46.1-22.7a57.3,57.3,0,0,1,34.7,12.5,50.1,50.1,0,0,1,10.9,12.4C132.2,59,133.1,80.4,125.8,97.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M26.9,17.6C23.8,27.9,8,88.2,62,113.2c0,0,20.6-37.1-33.6-95.9A.9.9,0,0,0,26.9,17.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M30.8,27.8c.2,3.5.6,7.1,1,10.7s1,7.1,1.6,10.7a187.4,187.4,0,0,0,4.7,21,128.3,128.3,0,0,0,7.7,20.1c.8,1.6,1.6,3.2,2.5,4.8l2.9,4.6a58,58,0,0,0,6.7,8.3h0a.4.4,0,0,1,0,.5h-.5a61.8,61.8,0,0,1-6.8-8.5c-1-1.5-1.9-3-2.8-4.6s-1.7-3.2-2.5-4.8a120.8,120.8,0,0,1-7.6-20.3A189.1,189.1,0,0,1,33,49.2c-.6-3.5-1.1-7.1-1.5-10.7s-.8-7.1-1-10.7a.2.2,0,0,1,.2-.2h.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M17.5,71.3c-.7,7-3.2,48.3,35.1,57.5,0,0,8.6-26.8-34.2-58A.6.6,0,0,0,17.5,71.3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M21.4,77.3c.6,2.3,1.3,4.5,2,6.7l2.4,6.6c.8,2.1,1.7,4.3,2.7,6.4s1.9,4.3,2.9,6.4a111.2,111.2,0,0,0,7.1,12l1,1.4.6.7a1.8,1.8,0,0,0,.5.7,13.4,13.4,0,0,0,1.1,1.4l1.1,1.3a37.8,37.8,0,0,0,4.9,4.9h0c.1.2.2.4,0,.6s-.4.2-.5,0h0a47.2,47.2,0,0,1-5-5L41.1,120,40,118.6l-.5-.7-.5-.7-1-1.4a87.3,87.3,0,0,1-7-12.2c-1.1-2.1-2.1-4.2-3-6.4s-1.8-4.3-2.6-6.5-1.6-4.4-2.3-6.6-1.4-4.4-2-6.7c-.1-.1,0-.2.1-.2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M117.2,135.2,44.5,133a6.3,6.3,0,0,1-6-6.2V24.8a6.2,6.2,0,0,1,6.1-6.2l72.6-1.5a6.4,6.4,0,0,1,6.4,6.3V129A6.2,6.2,0,0,1,117.2,135.2Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M111,127l-60.4-1.8a5.4,5.4,0,0,1-5.1-5.4V31.6a5.4,5.4,0,0,1,5.1-5.4L111.1,25a5.2,5.2,0,0,1,5.3,5.3v91.4A5.3,5.3,0,0,1,111,127Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "g"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M107.6,123.1l-53.7-1.7a4.8,4.8,0,0,1-4.4-4.9v-81A4.7,4.7,0,0,1,54,30.6l53.6-1.2a4.7,4.7,0,0,1,4.7,4.9v83.9A4.7,4.7,0,0,1,107.6,123.1Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M85,130.4h0a.9.9,0,0,1-.8.9l-11.7.3c-.6.1-1-.6-.9-1.2h.1a.8.8,0,0,1,.8-.8,103.5,103.5,0,0,1,11.7-.2C84.7,129.3,85,129.8,85,130.4Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 80.5,
    cy: 21.6,
    r: 2.4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M75,40.7h33.9a1.4,1.4,0,0,1,1.3,1.5h0a1.4,1.4,0,0,1-1.3,1.5L75,43.9a1.4,1.4,0,0,1-1.3-1.4v-.2A1.4,1.4,0,0,1,75,40.7Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M75.1,33.8h34a1.4,1.4,0,0,1,1.3,1.5h0c-.1.8-.6,1.5-1.3,1.5l-34,.3a1.3,1.3,0,0,1-1.2-1.4v-.2A1.3,1.3,0,0,1,75.1,33.8Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M74.7,47.3h34a1.3,1.3,0,0,1,1.2,1.6h0a1.3,1.3,0,0,1-1.2,1.4l-34,.3a1.3,1.3,0,0,1-1.2-1.3V49C73.4,48.1,74,47.3,74.7,47.3Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M54.4,56.8h52.5c1.1,0,2,.7,2,1.5h0a1.9,1.9,0,0,1-2,1.5L54.5,60a1.8,1.8,0,0,1-1.9-1.4v-.2C52.4,57.5,53.3,56.8,54.4,56.8Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M54,63.8l40.8-.3a1.6,1.6,0,0,1,1.6,1.6h0a1.5,1.5,0,0,1-1.5,1.4l-40.8.4a1.5,1.5,0,0,1-1.6-1.3v-.2A1.4,1.4,0,0,1,54,63.8Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M54.4,72.9h52.4c1.1,0,2,.7,2,1.5h0a1.8,1.8,0,0,1-1.9,1.5l-52.5.2a1.8,1.8,0,0,1-1.9-1.4v-.2C52.3,73.6,53.2,72.9,54.4,72.9Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M53.6,80h41a1.5,1.5,0,0,1,1.5,1.5h0A1.5,1.5,0,0,1,94.6,83l-41,.2a1.5,1.5,0,0,1-1.5-1.4v-.2A1.4,1.4,0,0,1,53.6,80Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M53.9,89.3h52.4c1.2,0,2,.7,2,1.5h0a1.7,1.7,0,0,1-1.9,1.5L54,92.5a1.9,1.9,0,0,1-2-1.4v-.2C51.9,90.1,52.8,89.3,53.9,89.3Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M53.4,96.3h41a1.6,1.6,0,0,1,1.5,1.6h0a1.5,1.5,0,0,1-1.5,1.4l-41,.2a1.5,1.5,0,0,1-1.5-1.4v-.2A1.6,1.6,0,0,1,53.4,96.3Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M54.4,105.5h52.5a1.8,1.8,0,0,1,2,1.6h0a1.8,1.8,0,0,1-2,1.4l-52.4.2a1.8,1.8,0,0,1-1.9-1.3v-.2A1.7,1.7,0,0,1,54.4,105.5Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M53.9,113.3H94.4a1.3,1.3,0,0,1,1.5,1.5h0a1.4,1.4,0,0,1-1.5,1.4l-40.4.3a1.5,1.5,0,0,1-1.5-1.4v-.2A1.5,1.5,0,0,1,53.9,113.3Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "k"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M58.7,44.8l-1.9,5.8H54.3l6.3-18.4h2.9l6.2,18.4H67.2l-2-5.8Zm6-1.8-1.8-5.3c-.4-1.2-.6-2.3-.9-3.4h-.1a20.2,20.2,0,0,1-.9,3.3L59.2,43Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.3d7dd7a3af776eb4c7bc3ac3d662fbed.svg";
export { ForwardRef as ReactComponent };